import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
import { fade } from '@material-ui/core/styles';
export var defaultStatus = {
  error: {
    icon: 'error'
  },
  info: {
    icon: 'info'
  },
  success: {
    icon: 'tick'
  },
  warning: {
    icon: 'warning'
  }
};

var createErrorPalette = function createErrorPalette(_ref) {
  var type = _ref.type,
      red20 = _ref.red20,
      red500 = _ref.red500,
      white = _ref.white;

  if (type === 'light') {
    return _assign({}, defaultStatus.error, {
      color1: red20,
      color2: red500,
      color3: white
    });
  }

  return _assign({}, defaultStatus.error, {
    color1: fade(red500, 0.15),
    color2: red500,
    color3: white
  });
};

var createInfoPalette = function createInfoPalette(_ref2) {
  var type = _ref2.type,
      blue20 = _ref2.blue20,
      blue500 = _ref2.blue500,
      white = _ref2.white;

  if (type === 'light') {
    return _assign({}, defaultStatus.info, {
      color1: blue20,
      color2: blue500,
      color3: white
    });
  }

  return _assign({}, defaultStatus.info, {
    color1: fade(blue500, 0.15),
    color2: blue500,
    color3: white
  });
};

var createSuccessPalette = function createSuccessPalette(_ref3) {
  var type = _ref3.type,
      green20 = _ref3.green20,
      green500 = _ref3.green500,
      white = _ref3.white;

  if (type === 'light') {
    return _assign({}, defaultStatus.success, {
      color1: green20,
      color2: green500,
      color3: white
    });
  }

  return _assign({}, defaultStatus.success, {
    color1: fade(green500, 0.15),
    color2: green500,
    color3: white
  });
};

var createWarningPalette = function createWarningPalette(_ref4) {
  var type = _ref4.type,
      orange20 = _ref4.orange20,
      orange500 = _ref4.orange500,
      white = _ref4.white;

  if (type === 'light') {
    return _assign({}, defaultStatus.warning, {
      color1: orange20,
      color2: orange500,
      color3: white
    });
  }

  return _assign({}, defaultStatus.warning, {
    color1: fade(orange500, 0.15),
    color2: orange500,
    color3: white
  });
};

var createEmphasis = function createEmphasis(_ref5) {
  var color1 = _ref5.color1,
      color2 = _ref5.color2,
      color3 = _ref5.color3,
      rest = _objectWithoutProperties(_ref5, ["color1", "color2", "color3"]);

  return {
    low: _assign({
      background: color3,
      borderColor: color2,
      iconColor: color2
    }, rest),
    medium: _assign({
      background: color1,
      borderColor: color2,
      iconColor: color2
    }, rest),
    high: _assign({
      background: color2,
      borderColor: color2,
      iconColor: color2
    }, rest)
  };
};

var createOptions = function createOptions(palette) {
  var errorPalette = createErrorPalette(palette);
  var infoPalette = createInfoPalette(palette);
  var successPalette = createSuccessPalette(palette);
  var warningPalette = createWarningPalette(palette);
  return {
    info: createEmphasis(infoPalette),
    error: createEmphasis(errorPalette),
    warning: createEmphasis(warningPalette),
    success: createEmphasis(successPalette)
  };
};

var createGetStatus = function createGetStatus(options) {
  return function () {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        statusProp = _ref6.status,
        emphasis = _ref6.emphasis;

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    if (!hasOwnProperty.call(options, statusProp)) {
      return {};
    }

    var allEmphasis = options[statusProp];

    if (hasOwnProperty.call(allEmphasis, emphasis)) {
      return allEmphasis[emphasis];
    }

    return options[statusProp];
  };
};

export var createStatus = function createStatus(palette) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref7 = typeof status === 'function' ? status(palette) : status,
      otherGetStatus = _ref7.getStatus,
      otherOptions = _objectWithoutProperties(_ref7, ["getStatus"]);

  var options = createOptions(palette);
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getStatus: otherGetStatus || createGetStatus(mergedOptions)
  }, mergedOptions);
};